import { setCookie } from 'cookies-next';
import { useEffect } from 'react';
import { useSessionStore } from 'store/useSessionStore';

export const useSetLastVisitedProductCatalogNumbers = (newLastVisitedItemCatalogNumber: string) => {
    const lastVisitedProductsCatNumbers = useSessionStore((s) => s.lastVisitedProductsCatNumbers);
    const updateGeneralState = useSessionStore((s) => s.updateGeneralState);

    useEffect(() => {
        const isAlreadyAdded = lastVisitedProductsCatNumbers.some(
            (oldItemCatalogNumber) => oldItemCatalogNumber === newLastVisitedItemCatalogNumber,
        );

        let newLastVisitedItems;

        if (!isAlreadyAdded) {
            newLastVisitedItems = [newLastVisitedItemCatalogNumber, ...lastVisitedProductsCatNumbers];
        } else if (lastVisitedProductsCatNumbers.length > 0) {
            newLastVisitedItems = [
                newLastVisitedItemCatalogNumber,
                ...lastVisitedProductsCatNumbers.filter(
                    (oldItemCatalogNumber) => oldItemCatalogNumber !== newLastVisitedItemCatalogNumber,
                ),
            ];
        }
        updateGeneralState({ lastVisitedProductsCatNumbers: newLastVisitedItems?.slice(0, 15) });
        // console.log(lastVisitedProductsCatNumbers);
        setCookie('lastVisitedProducts', JSON.stringify(newLastVisitedItems?.slice(0, 15)), {
            path: '/',
            maxAge: 60 * 60 * 24 * 30,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newLastVisitedItemCatalogNumber]);
};
